import React from "react";
import { experience } from "../data/portfolioData";
import "./Experience.css";

const Experience = () => (
  <section id="experience" className="portfolio-section experience-section" data-scene-section="experience">
    <div className="section-wrap" data-animate="true">
      <header className="destination-heading">
        <div className="destination-label"><span>02</span><span>All experiences</span></div>
        <h2 className="section-title">Work that moved systems forward.</h2>
        <p className="section-lede">A route through integration engineering, full-stack delivery, applied AI, and product development.</p>
      </header>
      <ol className="experience-list">
        {experience.map((role, index) => (
          <li key={`${role.organization}-${role.period}`} className={`experience-entry ${index === 0 ? "is-current" : ""}`}>
            <span className="experience-index" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            <article>
              <div className="experience-heading">
                <h3>{role.title}</h3>
                <p>{role.organization} <span aria-hidden="true">·</span> {role.location}</p>
              </div>
              <p className="experience-period">{role.period}</p>
              <ul className="experience-summary">
                {role.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
              </ul>
              <p className="experience-technologies"><strong>Technologies:</strong> {role.technologies.join(", ")}</p>
            </article>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default Experience;
